import { z } from "zod";

export const zStringBoolean = z.enum(["true", "false"]).transform((v) => v === "true");
